// export const TableItemPerPage = 15
// export const TableItemPerPageList = [5, 15, 25, 50]
export const appConfig = window.appConfig
export const updatePeriod = appConfig.refresh || 20000
export const debounce = 5000
export const dateFormat = 'dd.MM.yyyy'
export const loadMoreCount = 20
